
import { Options, Vue } from 'vue-class-component';
import OptionHeader from './components/OptionHeader.vue';
import Game from './components/Game.vue';
@Options({
  components: {
    OptionHeader,
    Game,
  },
})
export default class App extends Vue {
  selectedVoice: any = null;
  setVoice(event: any) {
    this.selectedVoice = event;
  }
}
